// @flow

import EventEmitter from 'events';
import _ from 'lodash';

import Listener from './Listener';

export default class PMTEventEmitter extends EventEmitter {

  addListener(event: string, callback: Function) {
    // console.info('[Listener] ADD - ' + event + ' ' + callback);
    this.on(event, callback);
  }

  emitEvent(event: string) {
    console.info('[EVENT]', event);
    super.emit(event);
  }

  emit(event: string) {
    console.info('[EVENT]', event);
    super.emit(event);
  }

  addListeners(listeners: Array<Listener>) {
    _.each(listeners, (listener: Listener) => {
      if (!_.isFunction(listener.func)) {
        console.error(`[Listener] ADD - Invalid listener for event ${listener.event}`);
      }
      this.addListener(listener.event, listener.func);
    });
  }

  removeListeners(listeners: Array<Listener>) {
    _.each(listeners, (listener: Listener) => {
      if (!_.isFunction(listener.func)) {
        console.error(`[Listener] REMOVE - Invalid listener for event ${listener.event}`);
      }
      this.removeListener(listener.event, listener.func);
    });
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/flux/PMTEventEmitter.js